
  import { Component, Vue } from 'vue-property-decorator'
  import { Link } from '@/views/interfaces/dom.interface';

  @Component
  export default class PagesCoreFooter extends Vue {
    private links: Link[] = [
      {
        href: '#',
        text: 'Creative Tim',
      },
      {
        href: '#',
        text: 'About Us',
      },
      {
        href: '#',
        text: 'Blog',
      },
      {
        href: '#',
        text: 'Licenses',
      },
    ]
  }
